import handleNavigationData from "@services/HandleNavigationData.js";
import { useLoaderStore } from "@store/loader";
const loaderStore = useLoaderStore();
const SaveState = {
    async saveState(route, type) {
        const data = await handleNavigationData.getData(route);
        if (!data['url'] || data['url'] === '') {
            return data;
        }
        // if (loaderStore.isLoading) {
        //     console.log('saveState data2222', data);
        //     return data;
        // }
        let oldhistory = localStorage.getItem(`${type}-toggle-state`);
        let history = oldhistory ? JSON.parse(oldhistory) : [];
        let checkExistUrl = history.find(item => item['url'] == data['url']);
        
        if (!checkExistUrl) {
            history.push(data);
            localStorage.setItem(`${type}-toggle-state`, JSON.stringify(history));
        }
        
        return data;
    }

};
export default SaveState;
